export enum UserToMembershipTypesEnum {
	Annual = 'annual',
	Quarterly = 'quarterly',
	Monthly = 'monthly',
	Trial = 'trial',
}
